//requires: public\EnhancedContent.js
/**
 * 
 */




L.EnhancedContent.Linked = L.EnhancedContent.extend({

	statics: {
		TYPE: "linked"
	},
	
	initialize: function(source, options){
		L.EnhancedContent.prototype.initialize.call(this,source, options);
		this._contentLoadStatut = 'notLoaded';
	},
	
	getType: function(){
		return  L.EnhancedContent.Linked.TYPE;
	},
	
	getProperties(){
		return {'linkedId': this._contentTarget,'templateId':this._templateTarget};
	},
	
	setLinkedId: function(id){
		this._contentTarget = id;
	},
	
	getLinkedId: function(){
		return this._contentTarget;
	},
	
	setTemplateId: function(id){
		this._templateTarget = id;
		//templatesManager.loadTemplate(this._templateTarget);
	},
	
	getTemplateId: function(){
		return this._templateTarget;
	},
	
	loadContent: function(){

		if (this._contentLoadStatut == 'notLoaded' ){
			
		this._contentLoadStatut = 'loading';
			jQuery.get({
				url: pclm_ajax_object.ajaxurl,
				method: 'GET',
				data:{
					"nonce": pclm_ajax_object.nonce_uploaded_parts,
					"action":"uploaded_parts",
					"id":this.getLinkedId(),
					"part": this.getTemplateId(),
					"destid": ""
				},
				context: this,
				success: function(data){
					this.setContent(data.html);
					this._contentLoadStatut = 'loaded';
					if (this.listens('contentLoaded')){
						this.fire('contentLoaded');
					}
				},
				dataType: "json"
	
				}
			);
		}
	},
	
	setContent: function(content){
		this._content = content;
	},
	
	getContent: function(){
		return this._content;
	},
	
	getLoadStatut: function(){
		return this._contentLoadStatut;
	},
	
	toJSONable: function(){
		var jsonable= {};
		
		jsonable['type'] = this.getType();
		jsonable['linkedId'] = this.getLinkedId();
		jsonable['templateId'] = this.getTemplateId();
		return jsonable;
	}
	
	
});


L.EnhancedContent.linked = function (htmlId, options) {
    return new L.EnhancedContent.Linked(htmlId, options);
};


L.Popup.include({
	
	bindLinkedEnhancedContent: function(content){
		if((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Linked.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			content._source._source.on('preclick',this.onLinkedContentUpdate,content._source);
			content._source._source.on('mouseover',this.onLinkedContentLoad,content._source);
		}
	},
	
	onLinkedContentLoad: function(){
		this._enhancedContent.loadContent();
		this._contentLoadStatut = 'loading';
	},
	
	
	onLinkedContentUpdate: function(e){
		
		this._content = this.formatLinkedContent();
		if (this._source.setPopupContent){
			
			this._source.setPopupContent(this._content);
		}
	},
	
	unbindLinkedEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		content._source._source.off('preclick',null,this);
		content._source._source.off('mouseover',null,this);
		return 
	},
	
	formatLinkedContent: function(){
		
		var templateToDisplayHtml = jQuery(this._source._map._default_popup_template).clone()[0];
		
		switch (this._enhancedContent.getLoadStatut()){
			case 'loading':{
				jQuery(templateToDisplayHtml).find('.popup-content').html(this._source._map._loadingContent);
				this._enhancedContent.on('contentLoaded',this.onLinkedContentUpdate,this);
				
				break;
			}			
			case 'notLoaded':{
				this._enhancedContent.loadContent();
				this._enhancedContent.on('contentLoaded',this.onLinkedContentUpdate,this);
			}
			case 'loaded':{
				this._enhancedContent.off('contentLoaded');
				jQuery(templateToDisplayHtml).find('.popup-content').html(decodeURIComponent(this._enhancedContent.getContent()));
			}
			default:{
				
			}			 
		}

		

		
		return templateToDisplayHtml;
		
	}
});

L.Modal.include({
	
	bindLinkedEnhancedContent: function(content){
		if((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Linked.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			content._source._source.on('preclick',this.onLinkedContentUpdate,content._source);
			content._source._source.on('mouseover',this.onLinkedContentLoad,content._source);
		}
	},
	
	onLinkedContentLoad: function(){
		this._enhancedContent.loadContent();
		this._contentLoadStatut = 'loading';
	},
	
	
	onLinkedContentUpdate: function(e){
		
		this._content = this.formatLinkedContent();
		if (this._source.setModalContent){
			
			this._source.setModalContent(this._content);
		}
	},
	
	unbindLinkedEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		content._source._source.off('preclick',null,this);
		content._source._source.off('mouseover',null,this);
		return 
	},
	
	formatLinkedContent: function(){
		
		var templateToDisplayHtml = this._source._map._default_modal_template;
		var newTemplate = jQuery(templateToDisplayHtml).filter('#htmlModalId').attr('id',(this._htmlModalId.substr(1, this._htmlModalId.length)));

		if(this.options.vertivalCentered){
			jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-dialog-centered');
		}
		
		if(!this.options.animated){
			jQuery(templateToDisplayHtml).find('.modal').removeClass('fade');
		}	

		if(this.options.width){
			
			switch (this.options.width){
			case 'small':
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-sm');
				break;
			}
			case 'large':
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').addClass('modal-lg');
				break;
			}
			default:
			{
				jQuery(templateToDisplayHtml).find('.modal-dialog').removeClass('modal-sm');
				jQuery(templateToDisplayHtml).find('.modal-dialog').removeClass('modal-lg');
			}
			}			
		}
		
		if(this.options.className){
			jQuery(templateToDisplayHtml).addClass(this.options.className);
		}
		
		switch (this._enhancedContent.getLoadStatut()){
			case 'loading':{
				jQuery(templateToDisplayHtml).find('.modal-content').html(this._source._map._loadingContent);
				this._enhancedContent.on('contentLoaded',this.onLinkedContentUpdate,this);
				
				break;
			}			
			case 'notLoaded':{
				this._enhancedContent.loadContent();
				this._enhancedContent.on('contentLoaded',this.onLinkedContentUpdate,this);
			}
			case 'loaded':{
				this._enhancedContent.off('contentLoaded');
				if(jQuery(templateToDisplayHtml).hasClass('modal-loading')){jQuery(templateToDisplayHtml).removeClass('modal-loading');}
				jQuery(templateToDisplayHtml).find('.modal-content').html(decodeURIComponent(this._enhancedContent.getContent()));
			}
			default:{
				
			}			 
		}

		

		
		return templateToDisplayHtml;
		
	}
});

L.Tooltip.include({
	
	bindLinkedEnhancedContent: function(content){
		if((content instanceof L.EnhancedContent) && (content.getType() == L.EnhancedContent.Linked.TYPE)){
			this._enhancedContent = content;
			content._source = this;
			
			jQuery.get({
				url: pclm_ajax_object.ajaxurl,
				method: 'GET',
				data:{
					"nonce": pclm_ajax_object.nonce_uploaded_parts,
					"action":"uploaded_parts",
					"id":this.getEnhancedContent().getLinkedId(),
					"part": this.getEnhancedContent().getTemplateId(),
					"destid": ""
				},
				context: this,
				success: function(data){
					var templateToDisplayHtml = jQuery.parseHTML(data.html)[0];
					this.getEnhancedContent().setContent(templateToDisplayHtml);
					this.setContent(templateToDisplayHtml);
				},
				dataType: "json"

			});
		}
	},
		
	unbindLinkedEnhancedContent: function(){
		
		this._enhancedContent._source = undefined;
		unBinded = this._enhancedContent;
		this._enhancedContent = undefined;
		return 
	},
	
});
